import { UpdatePasswordForm } from '@onesource/components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/auth/update-password')({
  component: UpdatePassword,
});

function UpdatePassword() {
  return <UpdatePasswordForm redirectTo="/auth/login" minPasswordLength={8} />;
}
